const sectionTableBenefitsComparisonCss = `
[data-type='section-table-benefits-comparison'] [data-attribute='wrapper-container'] {
  padding: 40px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

[data-type='section-table-benefits-comparison'] .title-content h1,
[data-type='section-table-benefits-comparison'] .title-content h2,
[data-type='section-table-benefits-comparison'] .title-content h3 {
  font-size: 24px;
}

[data-type='section-table-benefits-comparison'] .wrapper-content {
  padding: 16px;
}

[data-type='section-table-benefits-comparison'] .wrap-table {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

[data-type='section-table-benefits-comparison'] .wrap-table figure {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100% !important;
}

[data-type='section-table-benefits-comparison'] .wrap-table table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100% !important;
}

[data-type='section-table-benefits-comparison'] .wrap-table table p {
  margin-bottom: 8px !important;
}

[data-type='section-table-benefits-comparison'] .wrap-table table img {
  width: 24px;
  height: 24px;
  object-fit: cover;
}

[data-type='section-table-benefits-comparison'] .wrap-table table thead tr th {
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  /* border-top: 1px solid var(--border-color, #e5e7eb); */
  /* border-right: 1px solid var(--border-color, #e5e7eb); */
}

[data-type='section-table-benefits-comparison'] .wrap-table table thead figure {
  width: 100% !important;
}

[data-type='section-table-benefits-comparison'] .wrap-table table tbody tr:nth-child(odd) {
  background-color: transparent;
}

[data-type='section-table-benefits-comparison'] .wrap-table table tbody td {
  border-right: 1px solid var(--border-color, #e5e7eb);
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

[data-type='section-table-benefits-comparison'] .wrap-table table tbody td:first-child {
  border-left: 1px solid var(--border-color, #e5e7eb);
}

[data-type='section-table-benefits-comparison'] .wrap-table table tbody td figure {
  width: 100% !important;
  display: flex;
  justify-content: center;
}

@container (max-width: 768px) {
  [data-type='section-table-benefits-comparison'] [data-attribute='wrapper-container'] {
    padding: 16px 0;
  }

  [data-type='section-table-benefits-comparison'] .title-content h1,
  [data-type='section-table-benefits-comparison'] .title-content h2,
  [data-type='section-table-benefits-comparison'] .title-content h3 {
    font-size: 16px;
  }

  [data-type='section-table-benefits-comparison'] .wrapper-content {
    padding: 8px;
  }
}
`;
export default sectionTableBenefitsComparisonCss;
